<template>
    <div>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-snackbar
            content-class="snackbar"
            :color="snackbar_background"
            right
            v-model="snackbar"
            :timeout="timeout"
        >
            <v-icon :color="snackbar_icon_color" :size="64">{{
                snackbar_icon
            }}</v-icon>
            <h2
                :style="{ color: snackbar_text_color + '!important' }"
                class="ml-16"
            >
                {{ snackbar_text }}
            </h2>

            <v-btn
                @click="snackbar = false"
                fab
                dark
                text
                small
                style="
                    margin-top: -6rem;
                    float: right !important;
                    margin-right: -1rem !important;
                "
            >
                <v-icon :color="snackbar_icon_color">mdi-window-close</v-icon>
            </v-btn>
        </v-snackbar>

        <v-row class="mt-2" v-if="type == 0">
            <v-col md="4" sm="4" lg="4">
                <v-select
                    @change="selectMacchinePP"
                    outlined
                    v-model="id_part_program"
                    label="Choose Part Program"
                    :items="part_program_list"
                    item-text="name"
                    item-value="id"
                    class="ml-1 pb-0"
                >
                </v-select>
            </v-col>

            <v-btn
                @click="
                    getPartProgram();
                    id_part_program = null;
                    singleProgram = {};
                    part_program_list = [];
                "
                small
                fab
                style="float: right"
                class="mr-1 mt-5"
            >
                <v-icon color="primary">mdi-refresh</v-icon>
            </v-btn>
        </v-row>

        <!-- Part Program Card -->
        <v-card class="pt-0" v-show="singleProgram.id > 0">
            <v-toolbar dense class="primary" primary-title>
                <v-toolbar-title class="white--text">
                    Part Program: {{ this.singleProgram.name }}</v-toolbar-title
                >
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            @click="sendPartProgram"
                            v-on="on"
                            v-bind="attrs"
                            small
                        >
                            <v-icon color="success"> mdi-send </v-icon>
                        </v-btn>
                    </template>
                    <span>Invio part program a box</span>
                </v-tooltip>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            @click="sendPartProgram2"
                            v-on="on"
                            v-bind="attrs"
                            small
                            class="ml-2"
                        >
                            <v-icon color="purple"> mdi-send </v-icon>
                        </v-btn>
                    </template>
                    <span>Invio part program a backend</span>
                </v-tooltip>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-if="type != 0"
                            class="ml-2"
                            v-on="on"
                            v-bind="attrs"
                            @click="getPartProgram()"
                            small
                        >
                            <v-icon color="primary">mdi-refresh</v-icon>
                        </v-btn>
                    </template>
                    <span>Aggiornare</span>
                </v-tooltip>
                <v-spacer></v-spacer>
            </v-toolbar>

            <v-card-text>
                <v-row>
                    <v-col
                        md="5"
                        sm="5"
                        lg="5"
                        v-for="(it, index) in singleProgram.steps"
                        :key="index"
                    >
                        <v-row>
                            <DynamicInputVue
                                v-model="it.default_value"
                                :type="getInputType(it.type)"
                                :access="it.access_type"
                                :items="it.values"
                                :label="it.name"
                                class="mr-5"
                            />
                            <v-btn small @click="insertDate(it)" class="mt-5" v-if="getInputType(it.type) == 'string'"
                                ><v-icon color="primary"
                                    >mdi-calendar</v-icon
                                ></v-btn
                            >
                        </v-row>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-dialog v-model="date_dialog" width="30vw">
            <v-card>
                <v-toolbar dense class="primary" primary-title>
                    <v-toolbar-title class="white--text">
                        Inserimento Data
                    </v-toolbar-title>
                    <v-spacer />
                    <v-btn small @click="confirmInsert"
                        ><v-icon color="success">mdi-check</v-icon></v-btn
                    >
                    <v-spacer />
                    <v-btn small @click="date_dialog = false"
                        ><v-icon color="error">mdi-close</v-icon></v-btn
                    >
                </v-toolbar>
                <v-card-text>
                    <v-text-field
                        type="datetime-local"
                        v-model="tempDate"
                        label="Data"
                    ></v-text-field>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import DynamicInputVue from "./DynamicInput.vue";

export default {
    components: {
        DynamicInputVue,
    },
    props: {
        id_macchina: {
            type: Number,
        },
        id_articolo_ciclo_fasi: {
            type: Number,
        },
        id_commessa_dettaglio: {
            type: Number,
        },
    },

    data() {
        return {
            date_dialog: false,
            tempDate: null,
            tempItem: null,
            alert: new Object(),
            // variable be used to establish type of getPartProgram call.
            id_macchina_checked: null,
            id_articolo_ciclo_fasi_checked: null,
            id_commessa_dettaglio_checked: null,
            type: null,
            //  v-select for macchine part program
            id_part_program: null,
            part_program_list: [],

            overlay: false,
            // Snackbar
            snackbar: false,
            snackbar_background: "",
            snackbar_icon: "",
            snackbar_icon_color: "",
            snackbar_text: "",
            snackbar_text_color: "",
            timeout: 0,
            // Single Part Program
            singleProgram: {},
        };
    },
    mounted() {
        this.getPartProgram();
    },

    methods: {
        insertDate(arg) {
            this.tempItem = arg;
            this.date_dialog = true;
            this.tempDate = null;
        },
        confirmInsert() {
            this.tempItem.default_value = this.tempDate;
            this.date_dialog = false;
            this.tempDate = null;
        },
        // Function to select a pp and populate the Part program fileds
        selectMacchinePP() {
            let i = this.part_program_list.findIndex(
                (it) => it.id == this.id_part_program
            );
            this.singleProgram = this.part_program_list[i];
            console.log(this.singleProgram);
        },
        // Function used to link Dynamic Input type
        getInputType(type) {
            if (type == 0) {
                return "boolean";
            }
            if (type >= 1 && type <= 10) {
                return "number";
            }
            if (type == 11) {
                return "string";
            }
            if (type == 12) {
                return "file";
            }
            return null;
        },
        setCallType() {
            // Checking if incoming Props are number
            this.id_macchina_checked = Number(this.id_macchina);
            this.id_articolo_ciclo_fasi_checked = Number(
                this.id_articolo_ciclo_fasi
            );
            this.id_commessa_dettaglio_checked = Number(
                this.id_commessa_dettaglio
            );
            // Determining the type of get call
            // First check is for Macchine if it 0
            if (
                !isNaN(this.id_macchina_checked) &&
                isNaN(this.id_articolo_ciclo_fasi_checked) &&
                isNaN(this.id_commessa_dettaglio_checked)
            ) {
                this.type = 0;
            }
            // Second check for type=1 which is article
            if (
                !isNaN(this.id_macchina_checked) &&
                !isNaN(this.id_articolo_ciclo_fasi_checked) &&
                isNaN(this.id_commessa_dettaglio_checked)
            ) {
                this.type = 1;
            }
            // Third check for type=2 which is Commessa
            if (
                !isNaN(this.id_macchina_checked) &&
                isNaN(this.id_articolo_ciclo_fasi_checked) &&
                !isNaN(this.id_commessa_dettaglio_checked)
            ) {
                this.type = 2;
            }
        },
        // Function to get Part program in avanzamento
        getPartProgram() {
            this.overlay = true;
            this.setCallType();
            console.log(this.type);
            let request = {
                controller: "quickConnext",
                method: "POST",
                richiesta: {
                    action: "getassociatedpartprogramparameters",
                    token: localStorage.getItem("user_token"),
                    call_type: this.type,
                    id_macchina: this.id_macchina_checked,
                },
            };
            if (this.type == 1) {
                request.richiesta.id_articolo_ciclo_fasi =
                    this.id_articolo_ciclo_fasi_checked;
            }
            if (this.type == 2) {
                request.richiesta.id_commessa_dettaglio =
                    this.id_commessa_dettaglio_checked;
            }

            this.$store.dispatch("connext", request).then((res) => {
                if (this.type === 0) {
                    this.part_program_list = res.data;
                    if (this.part_program_list.length == 1) {
                        this.id_part_program = this.part_program_list[0].id;
                        this.selectMacchinePP();
                    }
                } else {
                    this.singleProgram = res.data;
                }
            });
            this.overlay = false;
        },

        // Function to send Part Program from avanzamento
        sendPartProgram() {
            for (
                let index = 0;
                index < this.singleProgram.steps.length;
                index++
            ) {
                const step = this.singleProgram.steps[index];
                if (
                    step.default_value === "" ||
                    step.default_value === undefined ||
                    step.default_value === null
                ) {
                    alert(`${step.name} should not be empty`);
                    return;
                }
                if (step.type >= 2 && step.type <= 11) {
                    if (
                        Number(step.default_value) <
                            Number(step.boundaries.hard_min_value) &&
                        step.boundaries.hard_min_value != null
                    ) {
                        alert(
                            `${
                                step.name
                            } should be greater than min value ${Number(
                                step.boundaries.hard_min_value
                            )}`
                        );
                        return;
                    } else if (
                        Number(step.default_value) >
                            Number(step.boundaries.hard_max_value) &&
                        step.boundaries.hard_max_value != null
                    ) {
                        alert(
                            `${
                                step.name
                            } should be less than max value ${Number(
                                step.boundaries.hard_max_value
                            )}`
                        );
                        return;
                    }
                }
            }
            this.overlay = true;
            let request = {
                controller: "quickConnext",
                method: "PUT",
                richiesta: {
                    action: "sendpartprogram",
                    token: localStorage.getItem("user_token"),
                    call_type: this.type,
                    id_macchina: this.id_macchina_checked,
                    part_program: this.singleProgram,
                },
            };
            this.setCallType();
            if (this.type == 1) {
                request.richiesta.id_articolo_dettaglio_4_0 =
                    this.singleProgram.id_articolo_dettaglio_4_0;
            }
            if (this.type == 2) {
                request.richiesta.id_commessa_dettaglio_4_0 =
                    this.id_commessa_dettaglio_checked;
            }
            this.$store
                .dispatch("connext", request)
                .then((res) => {
                    this.overlay = false;
                    if (res.status === 200) {
                        this.snackbar = true;
                        this.snackbar_background = "success";
                        this.snackbar_icon = "mdi-check";
                        this.snackbar_icon_color = "white";
                        this.snackbar_text =
                            "Part Program inviato correttamente";
                        this.snackbar_text_color = "white";
                        this.timeout = 3000;
                    }
                })
                .catch((err) => {
                    console.error(err);
                    this.overlay = false;
                    this.snackbar = true;
                    this.snackbar_background = "warning";
                    this.snackbar_icon = "mdi-alert";
                    this.snackbar_icon_color = "white";
                    this.snackbar_text = err.response.data;
                    this.snackbar_text_color = "white";
                    this.timeout = 0;
                });
        },

        sendPartProgram2() {
            for (
                let index = 0;
                index < this.singleProgram.steps.length;
                index++
            ) {
                const step = this.singleProgram.steps[index];
                if (
                    step.default_value === "" ||
                    step.default_value === undefined ||
                    step.default_value === null
                ) {
                    alert(`${step.name} should not be empty`);
                    return;
                }
                if (step.type >= 2 && step.type <= 11) {
                    if (
                        Number(step.default_value) <
                            Number(step.boundaries.hard_min_value) &&
                        step.boundaries.hard_min_value != null
                    ) {
                        alert(
                            `${
                                step.name
                            } should be greater than min value ${Number(
                                step.boundaries.hard_min_value
                            )}`
                        );
                        return;
                    } else if (
                        Number(step.default_value) >
                            Number(step.boundaries.hard_max_value) &&
                        step.boundaries.hard_max_value != null
                    ) {
                        alert(
                            `${
                                step.name
                            } should be less than max value ${Number(
                                step.boundaries.hard_max_value
                            )}`
                        );
                        return;
                    }
                }
            }
            this.overlay = true;
            let request = {
                controller: "sqlpartprogram",
                method: "POST",
                richiesta: {
                    action: "runpartprogram",
                    token: localStorage.getItem("user_token"),
                    call_type: this.type,
                    id_macchina: this.id_macchina_checked,
                    part_program: this.singleProgram,
                },
            };
            this.setCallType();
            if (this.type == 1) {
                request.richiesta.id_articolo_dettaglio_4_0 =
                    this.singleProgram.id_articolo_dettaglio_4_0;
            }
            if (this.type == 2) {
                request.richiesta.id_commessa_dettaglio_4_0 =
                    this.id_commessa_dettaglio_checked;
            }
            this.$store
                .dispatch("api6", request)
                .then((res) => {
                    this.overlay = false;
                    if (res.status === 200) {
                        this.snackbar = true;
                        this.snackbar_background = "success";
                        this.snackbar_icon = "mdi-check";
                        this.snackbar_icon_color = "white";
                        this.snackbar_text =
                            "Part Program inviato correttamente";
                        this.snackbar_text_color = "white";
                        this.timeout = 3000;
                    }
                })
                .catch((err) => {
                    console.error(err);
                    this.overlay = false;
                    this.snackbar = true;
                    this.snackbar_background = "warning";
                    this.snackbar_icon = "mdi-alert";
                    this.snackbar_icon_color = "white";
                    this.snackbar_text = err.response.data;
                    this.snackbar_text_color = "white";
                    this.timeout = 0;
                });
        },

        Goback() {
            this.$emit("GoBack");
        },
    },
};
</script>
